import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import { Link, graphql } from 'gatsby'
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import DisplayOccupationPosition from "../../components/community/display-occupation-position"
import "../../styles/pc/page/community/partner.scss"
import "../../styles/sp/page/community/partner.scss"

export default function PartnerPage({ data }) {
  return (
    <Layout>
      <Seo
        type="article"
        title="ジェイフィールのコミュニティ パートナー一覧"
        description=""
        bobyClassName="menu2"
        path="community/partner"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/community">Community</Link>　/　<Link to="/community/partner" className="current">Partner</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Partner</span></h2>
              <p className="subtitle"><span>一緒に変化をつくる仲間たち</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents_01">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              {/* <div className="inner_title">
                <div className="inner_title_in">
                  <h5 className="maintitle"><span>Partner</span></h5>
                </div>
              </div> */}
              {/*<div class="community_more"><Link to="/community/member"><span>view more</span></Link></div>*/}
              <div className="community_wrap">
                <ul className="community_box">
                  {data.allMicrocmsCommunities.edges.map(({ node }) => (
                    <li key={node.communitiesId}><Link to={'/community/partner/' + node.communitiesId}><span className="community_box_img"><LazyAndPreloadImage imgUrl={node.list_face_image ? node.list_face_image.url : ''} alt={"パートナー一覧"} /></span><span className="fs13">{node.name}</span><span className="fs12"><DisplayOccupationPosition position={node.position} occupation={node.occupation} /></span></Link></li>
                  ))}
                </ul>
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Community - </span><span className="txt">想いをつなぐコミュニティ</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query PartnerQuery {
  allMicrocmsCommunities(
    filter: {person_type: {eq: "パートナー"}},
    sort: {fields: sortIndex, order: ASC}
  ) {
    edges {
      node {
        communitiesId
        list_face_image {
          url
        }
        position
        occupation
        name
      }
    }
  }
}`
